import './dark-mode'
import './3rd-party/analytics'
import './3rd-party/artk'
//import './marquee'
import './ImageDesc'
import './breaking_news'
// import 'lazysizes'
import './jquery-oembed-all/jquery.oembed';
import './jquery-oembed-all/jquery.oembed.css';
import {autoChangeBanners} from './banners';
import './lazyload';

(() => {

    $('#preloader-style').remove();

    if ($(".default__item--content .embeddedContent").length) {
        // text = text.replace(/(\s|>|^)(https?:[^\s<]*)/igm,'$1<div><a href="$2" class="oembed">$2</a></div>');
        // text = text.replace(/(\s|>|^)(mailto:[^\s<]*)/igm,'$1<div><a href="$2" class="oembed">$2</a></div>');

        $.each($(".default__item--content .embeddedContent"), function (index, el) {
            let text = $(el).data('oembed');
            if (typeof text === 'undefined') {
                return;
            }
            try {
                text = text.replace(/(\s|>|^)(https?:[^\s<]*)/igm, '<a href="$2" class="oembed">$2</a>');

                $(el).html(text)
                $(el).find('.oembed').oembed(null, {
                    embedMethod: 'auto',	// "auto", "append", "fill"
                    apikeys: {
                        // amazon : '<your amazon key>',
                    },
                });

            } catch (e) {
                console.error(e)
            }
        })

    }


})();
